import { CSSObjectWithLabel } from 'react-select';
import { AnyType } from '@src/models/common';
import { CSSProperties } from 'react';

export const groupOptions = (options) => {
  const groupMap = new Map();

  for (const option of options) {
    const mapGroupName = option.groupName;

    if (groupMap.has(mapGroupName)) {
      groupMap.get(mapGroupName).options.push(option);
    } else {
      groupMap.set(mapGroupName, { label: mapGroupName, options: [option] });
    }
  }

  const groupArr = Array.from(groupMap.values());

  return groupArr;
};

export const getAllOptions = (options, isGroupedOptions) => {
  if (isGroupedOptions) {
    return options.map((el) => el.options).flat();
  } else {
    return options.flat();
  }
};

export const getExtraStyles = (fn: ((base: CSSObjectWithLabel, props: AnyType) => CSSObjectWithLabel) | undefined) => {
  return typeof fn === 'function'
    ? /** @link https://react-select.com/styles#the-styles-prop
     Передаем пустые объекты чтобы получить значение стилей извне, иначе будут подмешаны не нужные стили */
      (fn({}, {}) as CSSProperties)
    : undefined;
};
